// extracted by mini-css-extract-plugin
export default {"Toggle":"Toggle_Toggle__wQf-B","Slider":"Toggle_Slider__kGN0o"};